import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react"
import { AiOutlineClockCircle } from "react-icons/ai";
import { RiArrowRightUpLine } from "react-icons/ri";
import { Divider } from "@mui/material";
import recentSearchStyles from "./RecentSearches.module.css"

const RecentSearchResultBar = ({ keyId, name, slug, setSearchValue, setClearSearchItem, handleAccordionClose, handleAddressModalOpen, onOpenModal }) => {
  const history = useHistory();
  const city = useSelector((state) => state.cityOnTopNav.citySelect);

  const handleRecentSearchItemClear = (name) => {
    setClearSearchItem(name);
  }

  const handleRecentSearchClick = (slug) => {
    // (handleAccordionClose)()
    handleAddressModalOpen(slug, "book");
    // router.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`)
    // setTimeout(() => { router.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`) }, 500);
  }

  return (
    <div key={keyId} className={recentSearchStyles.resultBar}>
      <AiOutlineClockCircle className={recentSearchStyles.resultBarLeftIcon} />
      <span
        className={recentSearchStyles.resultBarName}
        onClick={() => onOpenModal()}
      >
        {name}
      </span>
      <span
        className={recentSearchStyles.resultBarRemove}
        onClick={() => handleRecentSearchItemClear(name)}
      >
        remove
      </span>
      <RiArrowRightUpLine
        className={recentSearchStyles.resultBarRightIcon}
        // onClick={() => handleRecentSearchClick(slug)}
        onClick={(e) => {
          console.log("Recent search Click Event", e);
          // setSearchValue(name);
          document.getElementById("search-accordion-input").value = name;
          document.getElementById("search-accordion-input").focus();
        }}
      />
      <Divider />
    </div>
  )
}

const RecentSearches = ({ searchValue, setSearchValue, handleAccordionClose, handleAddressModalOpen, onOpenModal }) => {
  const [recentSearches, setRecentSearches] = useState([]);
  const [clearSearchItem, setClearSearchItem] = useState("");

  // Getting Recent Searches From Local Storage ans Setting "setRecentSearches"
  useEffect(() => {
    let tmpRecentSearches = [];
    try {
      tmpRecentSearches = JSON.parse(localStorage.getItem("recentImagineSearches"));
      if (!tmpRecentSearches) {
        tmpRecentSearches = [];
      }
    }
    catch {
      tmpRecentSearches = [];
    }
    setRecentSearches([...tmpRecentSearches]);
  }, [setRecentSearches]);

  useEffect(() => {
    if (clearSearchItem !== "") {
      let tmpRecentSearches = recentSearches.filter(searchItem =>
        searchItem.name !== clearSearchItem
      );

      console.log("In Clear", clearSearchItem);
      if (tmpRecentSearches.length === 0) {
        localStorage.removeItem("recentImagineSearches")
      }
      else {
        localStorage.setItem("recentImagineSearches", JSON.stringify(tmpRecentSearches));
      }
      setRecentSearches([...tmpRecentSearches]);
      setClearSearchItem("");
    }
  }, [clearSearchItem])

  const handleClearAllRecentSearches = () => {
    setTimeout(() => {
      localStorage.removeItem("recentImagineSearches");
      setRecentSearches([]);
    }, 250);
  }

  return (
    <>
      {(recentSearches.length > 0) ?
        <div className={recentSearchStyles.container}>
          <div className={recentSearchStyles.headingDiv}>
            <span className={recentSearchStyles.heading}> Recent Searches</span>
            <span
              className={recentSearchStyles.clearAll}
              onClick={handleClearAllRecentSearches}
            >
              Clear All
            </span>
          </div>
          {recentSearches
            .filter(recentSearchObj =>
              recentSearchObj.name.toLowerCase().includes(searchValue.toLowerCase()))
            .map((filteredSearchObj, index) => {
              if (index < 4) {
                return (
                  < RecentSearchResultBar
                    keyId={index}
                    name={filteredSearchObj.name}
                    slug={filteredSearchObj.slug}
                    setSearchValue={setSearchValue}
                    setClearSearchItem={setClearSearchItem}
                    handleAccordionClose={handleAccordionClose}
                    handleAddressModalOpen={handleAddressModalOpen}
                    onOpenModal={onOpenModal}
                  />
                )
              }
            })
          }
          {/* <RecentSearchResultBar name={'Smart Full Body Checkup'} />
              <RecentSearchResultBar name={'Smart Full Body Checkup'} />
              <RecentSearchResultBar name={'Smart Full Body Checkup'} />
              <RecentSearchResultBar name={'Smart Full Body Checkup'} /> */}
          < Divider />
        </div>
        : null}
    </>
  )
}

export default RecentSearches;